<template functional>
  <div>
    {{ $options.codes(props.value) }}
  </div>
</template>
<script>
import gql from "fraql";
import { compact, uniq } from "lodash-es";
export default {
  name: "AppShowEventcodes",
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  codes(codes) {
    let eventcodes = codes
      .filter(x => x)
      .map(function(item) {
        if (item.eventcode) return item.eventcode.name;
      });
    return compact(uniq(eventcodes)).join(" | ");
  },
  fragments: {
    eventcode: gql`
      fragment _ on Eventcode {
        id
        name
      }
    `
  }
};
</script>
